import { useState } from 'react';
import { message } from 'antd';

import downloadBlobFile from '../../lib/utils/common/downloadBlobFile';
import { buildProductCategoryLinkCsvSample } from '../../lib/utils/productCategoryLinkBulkUtils';
import {
  PRODUCT_CATEGORY_LINK_BULK_CSV_CONTENT_TYPE,
  PRODUCT_CATEGORY_LINK_CSV_SAMPLE_FILE_NAME,
} from '../../constants/service/app/productCategoryLinkBulkConstants';

const useExcelBulkCategoryProductUploadModal = () => {
  // 업로드 모달 노출 여부 상태
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  // 업로드 할 파일 상태
  const [file, setFile] = useState(null);

  // 업로드 모달 노출 여부 상태 조정 메서드
  const openUploadModal = () => setIsUploadModalOpen(true);
  const closeUploadModal = () => setIsUploadModalOpen(false);

  const onChangeFile = (file) => setFile(file);
  const initializeFile = () => setFile(null);

  /**
   * 샘플 CSV 다운로드
   *
   * S3 정적 파일(xlsx)을 내려주던 방식에서 클라이언트 생성으로 바꿨다. 워커가 첫 행을
   * 헤더 문자열과 완전 일치로 검증하므로, 헤더를 코드에서 통제해야 샘플과 검증이 어긋나지 않는다.
   * BOM(U+FEFF)을 붙여야 엑셀에서 한글이 깨지지 않는다.
   */
  const downloadSample = () => {
    const blob = new Blob(['\uFEFF' + buildProductCategoryLinkCsvSample()], {
      type: PRODUCT_CATEGORY_LINK_BULK_CSV_CONTENT_TYPE,
    });

    downloadBlobFile(blob, PRODUCT_CATEGORY_LINK_CSV_SAMPLE_FILE_NAME);
  };

  /**
   * CSV 파일을 제출했을 때 실행되는 메서드
   *
   * 비동기 잡으로 바뀌어 응답으로 행별 결과를 받지 않는다. 요청만 넘기고 모달을 닫으며,
   * 이후 진행 상황·결과·실패 행 다운로드는 페이지의 진행 상태 카드가 담당한다.
   *
   * @param upload - 벌크 업로드 실행 함수 (useProductCategoryLinkBulkJob). 사전 검증 실패 시 false 반환
   */
  const onSubmit = (upload) => {
    if (!file) {
      message.error('업로드할 파일을 선택해 주세요.');
      return;
    }

    // 용량 초과 등으로 거절되면 모달을 닫지 않는다 — 선택한 파일만 바꿔 다시 시도할 수 있게
    if (!upload(file)) {
      return;
    }

    initializeFile();
    closeUploadModal();
  };

  return {
    file,
    isUploadModalOpen,
    openUploadModal,
    closeUploadModal,
    onChangeFile,
    initializeFile,
    downloadSample,
    onSubmit,
  };
};

export default useExcelBulkCategoryProductUploadModal;
